import { styled, Link } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  gap: theme.spacing(0),
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(6, 12),
}));

export const MobileRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0),

  '&:last-child': {
    marginBottom: 'unset',
  },
}));

export const MainCategory = styled(Link)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  width: '100%',
  fontSize: '1.6rem',
  textDecoration: 'none',
}));

export const SubItem = styled('li')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  listStyleType: 'none',
  fontSize: '1.6rem',
  margin: theme.spacing(4),

  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(2, 0),
    '&:last-child': {
      marginBottom: theme.spacing(6),
    },
  },
}));

export const SubLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  fontSize: '1.7rem',

  [theme.breakpoints.up('sm')]: {
    fontSize: '1.6rem',
  },
}));
